const en = {
  nav: {
    home: "Home",
    about: "About",
    experience: "Experience",
    projects: "Projects",
    resume: "Resume",
  },
  hero: {
    titlePrefix: "Hi,",
    titleName: "Jesus here.",
    subtitle:
      "Frontend / Full-Stack Developer building web applications with React, Next.js, TypeScript, Python and Django REST Framework.",
    secondary: "UX/UI background · SaaS experience · Open to Frontend and Full-Stack roles",
    ctaProjects: "View projects",
    ctaResume: "Download Resume",
    ctaContact: "Say hi",
  },
  about: {
    title: "About me",
    paragraphOne:
      "I’m a <b>Frontend / Full-Stack Developer</b> with a background in graphic design and <b>UX/UI</b>. I enjoy building web applications that not only work well technically, but are also clear, usable and easy to understand.",
    paragraphTwo:
      "I mainly work with <b>React</b>, <b>Next.js</b>, <b>TypeScript</b>, <b>Python</b> and <b>Django REST Framework</b>. I have developed features for SaaS platforms, integrating frontend and backend flows, creating REST endpoints and automating administrative processes with Python.",
    paragraphThree:
      "My approach combines development, product thinking and interface design: I care about maintainable code, reusable components and the final user experience.",
    techTitle: "Main stack",
    tech: [
      "TypeScript",
      "React",
      "Next.js",
      "Python",
      "Django REST Framework",
      "PostgreSQL",
      "MySQL",
      "Tailwind CSS",
      "Docker",
    ],
  },
  experience: {
    title: "Experience",
    ticsa: {
      role: "Full-Stack Developer @ Ticsa",
      duration: "Feb 2024 — Jul 2024",
      bullets: [
        "Built features for an operational and administrative SaaS platform using React, TypeScript, Python, Django REST Framework and MySQL.",
        "Worked on HR, invoices and payroll modules used by approximately 100 users across 3 client organizations.",
        "Created REST API endpoints and Python scripts to automate recurring administrative processes such as monthly payroll and client invoice generation.",
      ],
    },
    dropsher: {
      role: "Front-End Developer / UX/UI Designer @ Dropsher",
      duration: "Nov 2022 — Feb 2023",
      bullets: [
        "Developed a responsive landing page for a SaaS-oriented product, translating Figma designs into reusable React components adaptable to different screen sizes.",
        "This experience connected my design background with my transition into frontend development.",
      ],
    },
  },
  projects: {
    title: "Projects",
    featuredTitle: "Featured projects",
    otherTitle: "Other projects",
    spendwise: {
      name: "Spendwise",
      description: "Full-stack personal finance app for tracking income, expenses, budgets and savings.",
      details:
        "Built with email and Google authentication, JWT sessions, private user data, responsive frontend and a Django REST Framework + PostgreSQL backend.",
      stack: "Next.js · TypeScript · Django REST Framework · PostgreSQL · JWT",
      demo: "https://spendwise-psi-silk.vercel.app/",
      github: "https://github.com/Pdwxn/spendwise",
    },
    coverLetterAi: {
      name: "Cover Letter AI",
      description:
        "AI-powered app that generates personalized cover letters based on user information and job context.",
      details:
        "Integrated Groq API with Llama 3.1 8B and prompt logic to generate clear, editable and contextualized outputs.",
      stack: "React · TypeScript · Groq API · Llama 3.1 8B",
      demo: "https://cover-letter-ai-zeta.vercel.app/",
      github: "https://github.com/Pdwxn/Cover-letter-ai",
    },
    authTransparency: {
      name: "Auth Transparency",
      description:
        "Educational web app for visualizing authentication flows and user state changes in real time.",
      details:
        "Built to make abstract authentication processes easier to understand through an interactive interface.",
      stack: "React · TypeScript · NextAuth · Tailwind CSS",
      demo: "https://auth-transparency.vercel.app/",
      github: "https://github.com/Pdwxn/auth-transparency",
    },
    others: [
      {
        name: "AI Code Reviewer",
        description:
          "Web tool that uses artificial intelligence to analyze, improve, and understand code in real time.",
        stack: "Next.js · TypeScript · Tailwind CSS · Groq API",
        demo: "https://code-reviewer-ai-ten.vercel.app/",
        github: "https://github.com/Pdwxn/code-reviewer-ai",
      },
      {
        name: "World Wander Log",
        description:
          "App that allows you to store and track your trips with an intuitive and friendly interface.",
        stack: "React · TypeScript",
        demo: "https://worldwanderlog-app-reactjs.vercel.app/",
        github: "https://github.com/Pdwxn/worldwanderlog-app-reactjs",
      },
      {
        name: "CardStone",
        description: "App for exploring more than 3,000 Hearthstone cards.",
        stack: "React · TypeScript · Tailwind CSS",
        demo: "https://card-stone.vercel.app/",
        github: "https://github.com/Pdwxn/CardStone",
      },
      {
        name: "Pomodoro Timer",
        description:
          "Pomodoro timer app with a simple and functional interface.",
        stack: "Next.js · TypeScript · Tailwind CSS",
        demo: "https://pomodor-timer-flame.vercel.app",
        github: "https://github.com/Pdwxn/pomodor-timer",
      },
    ],
  },
  contact: {
    title: "Let’s work together",
    body:
      "I’m open to Frontend and Full-Stack roles with remote-first teams across LATAM, North America and Europe.",
    cta: "Send email",
  },
};

export default en;
  
